/**
 * FG Sitemap Balancer
 * 
 * Questo script ottimizza la distribuzione dei link all'interno 
 * delle colonne della sitemap per un layout più bilanciato e ordinato.
 */

document.addEventListener('DOMContentLoaded', function() {
  function ottimizzaColonneSitemap() {
    const sitemapSections = document.querySelectorAll('.link-list-blocks');
    
    sitemapSections.forEach(function(section) {
      const columns = Array.from(section.querySelectorAll('[data-sitemap-column]'));
      
      if (columns.length <= 1) return;
      
      function normalizeLinkElement(node) {
        const anchor = node.tagName === 'A' ? node : node.querySelector && node.querySelector('a');
        if (!anchor) {
          return node;
        }

        const aClone = anchor.cloneNode(true);

        try {
          const requiredAnchorClasses = ['hover:tw-text-brown', '[&]:hover:tw-underline'];
          requiredAnchorClasses.forEach(c => { if (!aClone.classList.contains(c)) aClone.classList.add(c); });
        } catch (e) {
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'tw-py-4 tw-text-black';
        wrapper.appendChild(aClone);

        return wrapper;
      }

      const allLinks = [];
      columns.forEach(column => {
        const links = Array.from(column.querySelectorAll('.tw-py-4.tw-text-black:not([data-sitemap-column])'));
        links.forEach(link => {
          const rect = link.getBoundingClientRect();
          const height = rect.height || link.offsetHeight || 0;

          const normalized = normalizeLinkElement(link);

          allLinks.push({ el: normalized, height });

          link.remove();
        });
      });

      if (allLinks.length === 0) return;

      columns.forEach(col => col.innerHTML = '');

      allLinks.sort((a, b) => {
        function textOf(item) {
          try {
            const aEl = item.el.querySelector && item.el.querySelector('a');
            return (aEl ? aEl.textContent : item.el.textContent || '').trim().toLowerCase();
          } catch (e) { return '' + (item.el.textContent || ''); }
        }
        return textOf(a).localeCompare(textOf(b), undefined, { sensitivity: 'base' });
      });

      const totalHeight = allLinks.reduce((s, it) => s + (it.height || 0), 0);
      const idealPerColumn = totalHeight / columns.length;

      let currentCol = 0;
      let currentColHeight = 0;

      for (let idx = 0; idx < allLinks.length; idx++) {
        const item = allLinks[idx];

        const remainingItems = allLinks.length - idx;
        const remainingCols = columns.length - currentCol;

        if (currentCol < columns.length - 1) {
          const shouldMoveForBalance = currentColHeight >= idealPerColumn;
          const mustLeaveOneEach = remainingItems <= remainingCols;
          if (shouldMoveForBalance || mustLeaveOneEach) {
            currentCol++;
            currentColHeight = 0;
          }
        }

        columns[currentCol].appendChild(item.el);
        currentColHeight += item.height || 0;
      }
    });
  }
  
  setTimeout(ottimizzaColonneSitemap, 300);
  
  window.addEventListener('load', ottimizzaColonneSitemap);
});